// extracted by mini-css-extract-plugin
export default {"contentFadeIn":"QwtzW2","articleSidebarFadeIn":"ZTddsH"};